import React, { FC, useCallback, useState } from 'react'
import axios from 'axios';
import { styled } from '@pixel/core/styles'
import LocalizedButton from '../components/LocalizedButton'
import { LocalizedText } from '../contexts/Localization/LocalizationTypes'
import FieldListLandingPageHeader from "./components/FieldListsLandingPageHeader";
import FieldListsListBase, { FieldListSelectedCallback } from './components/FieldListsListBase';
import FieldListFormModal from "./components/FieldListFormModal";
import { AssociatedAutomation, FieldListSearchResult, FieldListStatusType } from './types/FieldList';
import FieldListViewModal from "./components/FieldListViewModal";
import FieldListStatusAlert from './components/FieldListStatusAlert';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const FieldListContainer = styled('div')({
})

interface FieldListProps {
}

export const FieldList: FC<FieldListProps> = () => {
    const [modalOpen, setModalOpen] = useState(false)
    const [statusAlertOpen, setStatusAlertOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false)
    const [selectedFieldList, setSelectedFieldList] = useState<FieldListSearchResult>(null)
    const [selectedFieldListAssociatedAutomations, setSelectedFieldListAssociatedAutomations] = useState<Array<AssociatedAutomation>>([])
    const [selectedFieldListId, setSelectedFieldListId] = useState(0);
    const [refetch, setRefetch] = useState(false);

    const handleNewFieldListSelected = () => {
        setSelectedFieldList(null)
        setModalOpen(true)
        window.scrollTo({ top: 0 })
    }

    const handleFieldListSelected: FieldListSelectedCallback = useCallback((fieldList: any) => {
        if (fieldList) {
            setSelectedFieldListId(fieldList.fieldListId);
            setModalOpen(true)
            window.scrollTo({ top: 0 })
        }
    }, []);


    const handleFieldListSelectedView: FieldListSelectedCallback = useCallback((fieldList: any) => {
        if (fieldList) {
            setSelectedFieldListId(fieldList.fieldListId);
            setViewModalOpen(true)
            window.scrollTo({ top: 0 })
        }
    }, [])

    const handleFieldListStatusAlert = useCallback((fieldList: FieldListSearchResult, associatedAutomations: Array<AssociatedAutomation>) => {
        if (fieldList && associatedAutomations.length) {
            setSelectedFieldList(fieldList);
            setSelectedFieldListAssociatedAutomations(associatedAutomations);
            setStatusAlertOpen(true);
            window.scrollTo({ top: 0 });
        }
    }, []);

    const queryClient = useQueryClient();

    const changeStatus = async (fieldList: FieldListSearchResult) => {
        const newStatus: FieldListStatusType = fieldList.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
        const CHANGE_FIELD_LIST_STATUS_ENDPOINT = `/admin/action/automation/admin/updateFieldListStatus/${fieldList.fieldListId}/status/${newStatus}`;
        try {
            const response = await axios.put(CHANGE_FIELD_LIST_STATUS_ENDPOINT);
            if (response.status === 201 || response.status === 200) {
                if (response.data?.validationError && response.data.errors?.[0]?.entities?.associatedAutomations?.length) {
                    const associatedAutomations: Array<AssociatedAutomation> = response.data.errors[0].entities.associatedAutomations;
                    handleFieldListStatusAlert(fieldList, associatedAutomations);
                } else {
                    fieldList.status = newStatus;
                    fetchData();
                }
            }
        } catch (e) {
            console.error(e);
        }
        await queryClient.invalidateQueries({
            queryKey: ['updateFieldList']
        });
    };

    const changeStatusMutation = useMutation(changeStatus);

    const onStatusChange = (fieldList: FieldListSearchResult): void => {
        changeStatusMutation.mutate(fieldList);
    }

    const fetchData = () => {
        setRefetch(!refetch);
    }

    return (
        <FieldListContainer>
            <FieldListLandingPageHeader>
                <LocalizedButton
                    variant="contained"
                    color="primary"
                    text={LocalizedText.FIELD_LIST_CREATE_BUTTON}
                    onClick={handleNewFieldListSelected}
                />
            </FieldListLandingPageHeader>

            <FieldListsListBase
                onFieldListSelected={handleFieldListSelected}
                viewFieldListSelected={handleFieldListSelectedView}
                changeFieldListStatus={onStatusChange}
                fetchData={() => fetchData()}
                refetch={refetch}
            />

            <FieldListFormModal
                open={modalOpen}
                selectedFieldListId={selectedFieldListId}
                onClose={() => {
                    setModalOpen(false)
                    setSelectedFieldListId(0)
                }}
                fetchData={()=>fetchData()}
            />

            <FieldListViewModal
                open={viewModalOpen}
                selectedFieldListId={selectedFieldListId}
                onClose={() => {
                    setViewModalOpen(false)
                    setSelectedFieldListId(0)
                }}

            />
            <FieldListStatusAlert
                open={statusAlertOpen}
                selectedFieldList={selectedFieldList}
                associatedAutomations={selectedFieldListAssociatedAutomations}
                onClose={() => {
                    setStatusAlertOpen(false);
                    setSelectedFieldList(null);
                    setSelectedFieldListAssociatedAutomations([]);
                }}
            />
        </FieldListContainer>
    )
}

export default FieldList
